// src/i18n.js -> https://github.com/kaisermann/svelte-i18n
import { register, init, getLocaleFromNavigator } from 'svelte-i18n';

register('en', () => import('./locales/en.json'));
register('es', () => import('./locales/es.json'));

let nav_locale = getLocaleFromNavigator();
if(nav_locale.includes("-")){
  nav_locale = nav_locale.split("-")[0];
}
init({
  fallbackLocale: 'en',
  initialLocale: nav_locale,
});
